import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Delete from './actions/delete';
import Resource from './resource';

export default class Share extends Resource {
  get resourceName() {
    return 'share';
  }

  get resourcesName() {
    return 'shares';
  }
}
// @ts-ignore
List.includeInto(Share);
// @ts-ignore
Find.includeInto(Share);
// @ts-ignore
Create.includeInto(Share);
// @ts-ignore
Delete.includeInto(Share);
